/* TargetShop SEO – theme.js
   Vanilla JS, ~4 KB, deferred. Alles funktioniert auch ohne JS (Progressive Enhancement). */
(function () {
  'use strict';

  const strings = (window.theme && window.theme.strings) || {};
  const routes = (window.theme && window.theme.routes) || {};

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(html) {
    let el = document.querySelector('.toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.innerHTML = html;
    requestAnimationFrame(() => el.classList.add('is-visible'));
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-visible'), 4000);
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count > 0 ? count : '';
    });
  }

  /* ---------- AJAX Add to Cart ---------- */
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-product-form]');
    if (!form || !window.fetch) return;
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    if (button) button.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Error');
      const cart = await (await fetch(routes.cart_url + '.js')).json();
      updateCartCount(cart.item_count);
      toast(`<span>${strings.added}</span><a href="${routes.cart_url}">→</a>`);
    } catch (err) {
      toast(`<span>${err.message}</span>`);
    } finally {
      if (button) button.removeAttribute('aria-busy');
    }
  });

  /* ---------- Quantity ---------- */
  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-qty]');
    if (!btn) return;
    const input = btn.parentElement.querySelector('input');
    const step = Number(btn.dataset.qty);
    const min = Number(input.min || 0);
    input.value = Math.max(min, Number(input.value || 0) + step);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Variant Picker ---------- */
  document.querySelectorAll('[data-variant-picker]').forEach((picker) => {
    const section = picker.closest('[data-product]');
    const dataEl = section.querySelector('[data-product-json]');
    if (!dataEl) return;
    const variants = JSON.parse(dataEl.textContent);
    const idInput = section.querySelector('[data-variant-id]');
    const priceEl = section.querySelector('[data-price-wrapper]');
    const button = section.querySelector('[data-add-button]');
    const skuEl = section.querySelector('[data-sku]');
    const fieldsets = picker.querySelectorAll('fieldset');

    function selectedOptions() {
      return Array.from(fieldsets).map((fs) => {
        const checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function markAvailability(current) {
      fieldsets.forEach((fs, index) => {
        fs.querySelectorAll('input').forEach((input) => {
          const candidate = current.slice();
          candidate[index] = input.value;
          const match = variants.find((v) => v.options.every((o, i) => o === candidate[i]));
          input.nextElementSibling.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
    }

    function onChange() {
      const options = selectedOptions();
      const variant = variants.find((v) => v.options.every((o, i) => o === options[i]));
      markAvailability(options);
      if (!variant) {
        if (button) { button.disabled = true; button.textContent = strings.unavailable; }
        return;
      }
      idInput.value = variant.id;
      if (priceEl) {
        let html = variant.compare
          ? `<span class="price__current">${variant.price}</span><s class="price__compare">${variant.compare}</s>`
          : `<span class="price__current">${variant.price}</span>`;
        if (variant.unit) html += `<span class="price__unit">${variant.unit}</span>`;
        priceEl.innerHTML = `<div class="price${variant.compare ? ' price--sale' : ''}">${html}</div>`;
      }
      if (skuEl) {
        skuEl.textContent = variant.sku || '';
        const row = skuEl.closest('[data-detail]'); if (row) row.hidden = !variant.sku;
      }
      const gtinEl = section.querySelector('[data-gtin]');
      if (gtinEl) {
        gtinEl.textContent = variant.gtin || '';
        const row = gtinEl.closest('[data-detail]'); if (row) row.hidden = !variant.gtin;
      }
      if (button) {
        button.disabled = !variant.available;
        button.textContent = variant.available ? strings.addToCart : strings.soldOut;
      }
      if (variant.media) {
        const media = section.querySelector(`[data-media-id="${variant.media}"]`);
        if (media) media.parentElement.scrollTo({ left: media.offsetLeft - media.parentElement.offsetLeft, behavior: 'smooth' });
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    picker.addEventListener('change', onChange);
    markAvailability(selectedOptions());
  });

  /* ---------- Collection filters: auto-submit ---------- */
  document.querySelectorAll('[data-facets-form]').forEach((form) => {
    let timer;
    form.addEventListener('change', () => {
      clearTimeout(timer);
      timer = setTimeout(() => form.submit(), 400);
    });
  });
  document.querySelectorAll('[data-sort]').forEach((select) => {
    select.addEventListener('change', () => select.form.submit());
  });

  /* ---------- Cart page: auto-update quantities ---------- */
  const cartForm = document.querySelector('[data-cart-form]');
  if (cartForm) {
    let timer;
    cartForm.addEventListener('change', (event) => {
      if (!event.target.matches('input[name="updates[]"]')) return;
      clearTimeout(timer);
      timer = setTimeout(() => {
        const update = document.createElement('input');
        update.type = 'hidden';
        update.name = 'update';
        update.value = '1';
        cartForm.appendChild(update);
        cartForm.submit();
      }, 600);
    });
  }

  /* ---------- Product recommendations (lazy) ---------- */
  document.querySelectorAll('[data-recommendations]').forEach((el) => {
    const load = async () => {
      try {
        const res = await fetch(el.dataset.url);
        const text = await res.text();
        const html = new DOMParser().parseFromString(text, 'text/html');
        const inner = html.querySelector('[data-recommendations]');
        if (inner && inner.innerHTML.trim().length) el.innerHTML = inner.innerHTML;
        else el.closest('.section').remove();
      } catch (e) { /* noop */ }
    };
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) { io.disconnect(); load(); }
      }, { rootMargin: '400px 0px' });
      io.observe(el);
    } else {
      load();
    }
  });

  /* ---------- Close menu drawer with Escape ---------- */
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('details[open].menu-drawer').forEach((d) => {
      d.removeAttribute('open');
      d.querySelector('summary').focus();
    });
  });
})();
